// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"553f87da","104":"386e5b4c","184":"591e152f","240":"ed3a9799","272":"522d5012","428":"a515463b","651":"35c77637","680":"86e90cae","692":"a9ea549a","700":"331f71c3","880":"6df80cfd","900":"0782031e"}[chunkId] + ".chunk.js";
};